import styled from "styled-components";
import styledMap from "styled-map";
import { transparentize } from "polished";
import { space, order, width } from "styled-system";

import theme from "config/theme";

import { H3, H6 } from "components/Text";
import Button from "components/Button";
import StyledImage from "components/Image";

export const Block = styled.div`
  ${width};
  ${space};
  ${order};
`;

export const Title = styled(H6)`
  margin-bottom: 20px;
  color: ${theme.color.primary};
  font-weight: ${theme.font.weight.regular};
`;

export const Heading = styled(H3)`
  color: ${props => (props.shade === "light" ? "white" : theme.color.gray)};

  font-size: ${styledMap("size", {
    large: theme.font.size.alpha,
    default: ""
  })};

  @media (max-width: ${theme.size.mobile}) {
    font-size: ${styledMap("size", {
      large: theme.font.size.cesar,
      default: ""
    })};
  }
`;

export const Content = styled.div`
  width: 100%;
  line-height: 1.7;
  padding: 5px 0;
  color: ${props =>
    props.shade === "light" ? theme.color.paper2 : theme.color.gray2};

  font-size: ${styledMap("size", {
    large: theme.font.size.upsilon,
    default: ""
  })};

  @media (max-width: ${theme.size.mobile}) {
    font-size: ${styledMap("size", {
      large: theme.font.size.delta,
      default: theme.font.size.epsilon
    })};
  }

  ${space};
`;

export const Preview = styled.div`
  width: 320px;
  height: 320px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  margin: 0 50px 0 auto;
  box-shadow: 0 3px 25px 0 ${transparentize(0.78, theme.color.gray)};
  background-color: ${theme.color.gray2};

  @media (max-width: ${theme.size.desktop}) {
    width: 280px;
    height: 280px;
    margin: 0 20px 0 auto;
  }

  @media (max-width: ${theme.size.tablet}) {
    margin: 40px 0 60px;
  }

  @media (max-width: ${theme.size.mobile}) {
    margin: 0 auto 40px;
  }
`;

export const Image = styled(StyledImage)`
  display: block;
  opacity: 0.4;
  width: 320px;
  height: 320px;
  object-fit: cover;
`;

export const PlayButton = styled(Button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding: 0;
  border: none;
  z-index: 2;
  transform-origin: left;

  &:active {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(0.96);
  }
`;
